import { Component, inject } from '@angular/core';
import { map } from 'rxjs';
import { PrimeNGButtonOpenItemViewActionComponent } from '@ntap/primeng';
import { ListViewProviderDirective } from '@ntap/core';

@Component({
  selector: 'app-promjena-zaduzenje-za-agenta-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class PromjenaZaduzenjaZaAgentaOpenItemViewActionComponent extends PrimeNGButtonOpenItemViewActionComponent {
  private listViewProvider = inject(ListViewProviderDirective);

  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.listViewProvider.selectedItems$.pipe(
      map((selectedItems) => {
        return selectedItems.length <= 0;
      })
    );
  }
}
